export function arrayToMap<TItem, TKey extends keyof TItem>(
  array: TItem[] = [],
  key: TKey,
): Map<TItem[TKey], TItem> {
  const map = new Map<TItem[TKey], TItem>();
  array.forEach((item) => map.set(item[key], item));
  return map;
}
